const DATABASE_WORKER_ACTIONS = Object.freeze({
  READ_FILE: 'read file',
  SAVE_FILE: 'save file',
  DELETE_FILE: 'delete file',
  SAVE_METADATA: 'save metadata',
  READ_METADATA: 'read metadata',
  DELETE_DATABASE: 'delete database',
})

export { DATABASE_WORKER_ACTIONS }